import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Seo from '../Seo/Seo'

const Terms = () => (
  <Box paddingTop={10} paddingBottom={6} paddingX={{ xs: 2, md: 6 }}>
    <Seo
      title="Terms of Service | Trivia Weekend"
      description="Review the Trivia Weekend terms of service for acceptable use, account responsibilities, and platform guidelines."
      canonicalPath="/#/terms"
      ogType="website"
    />
    <Typography variant="h3" component="h1" gutterBottom>
      Terms of Service
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Last updated: February 5, 2026
    </Typography>

    <Typography paragraph>
      Trivia Weekend is a free, community-driven trivia platform built for fun, friendly competition, and
      a little bragging rights. By using the site, you agree to these Terms. If you don’t agree, please
      don’t use the service.
    </Typography>

    <Typography paragraph>
      This service is provided “as-is” and “as-available.” We do our best to keep things running smoothly,
      but we can’t promise the site will always be perfect (or always online).
    </Typography>

    <Typography variant="h5" gutterBottom>
      Acceptable Use
    </Typography>
    <Typography component="div" paragraph>
      <ul>
        <li>Play fair and be respectful — help keep Trivia Weekend welcoming for everyone.</li>
        <li>Use the service in a lawful way and follow the rules of good sportsmanship.</li>
        <li>If you post or share anything, only share content you have the right to share.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>
      Prohibited Use
    </Typography>
    <Typography component="div" paragraph>
      <ul>
        <li>
          Don’t mess with the service: no hacking, probing, bypassing security, or trying to access other
          users’ data.
        </li>
        <li>
          Don’t disrupt the experience for others: no harassment, impersonation, hate speech, or deceptive
          behavior.
        </li>
        <li>
          Don’t overload the site: no scraping, reverse engineering, or automated access that creates
          unreasonable traffic.
        </li>
        <li>Don’t use the platform to upload or share illegal content.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>
      Intellectual Property
    </Typography>
    <Typography paragraph>
      Trivia Weekend (including our name, logo/branding, design, and software) is owned by Trivia Weekend
      or our licensors and is protected by applicable laws. You’re welcome to enjoy the service, but you
      may not copy, modify, distribute, sell, or create derivative works from it without permission.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Accounts
    </Typography>
    <Typography paragraph>
      If you create an account, you’re responsible for what happens under it. Please keep your login info
      secure and let us know if you think your account has been compromised.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Suspension or Termination
    </Typography>
    <Typography paragraph>
      We may suspend or terminate access if we believe these Terms were violated, if behavior is harming
      the community, or if we need to protect the service and its users. We’re not trying to be heavy-handed —
      we just need the ability to keep the site healthy and enjoyable.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Disclaimer of Warranties
    </Typography>
    <Typography paragraph>
      The service is provided “as-is” and “as-available,” without warranties of any kind. We don’t promise
      the service will be uninterrupted, secure, or error-free, and we can’t guarantee results (including
      that your trivia team will finally beat that one annoying rival team).
    </Typography>

    <Typography variant="h5" gutterBottom>
      Limitation of Liability
    </Typography>
    <Typography paragraph>
      To the maximum extent permitted by law, Trivia Weekend is not liable for any indirect, incidental,
      special, consequential, or punitive damages arising from your use of the service. Because the service
      is free, our total liability for any claim will not exceed $0.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Governing Law
    </Typography>
    <Typography paragraph>
      These Terms are governed by the laws of the State of Minnesota and the United States, without regard
      to conflict of law principles.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Changes to These Terms
    </Typography>
    <Typography paragraph>
      We may update these Terms from time to time. When we do, we’ll post the updated version here and
      update the “Last updated” date. If you keep using the service after an update, that means you accept
      the new Terms.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Contact Us
    </Typography>
    <Typography paragraph>
      Questions or concerns? Email us at <strong><a href="mailto:triviaweekendapp@gmail.com">triviaweekendapp@gmail.com</a></strong> — we’re happy to help.
    </Typography>
  </Box>
)

export default Terms
